import { AppLink, asCurrency, asDate, colors, div, Flex, getPercentValue, PageHeaderTile, PageTileField, ProgressCircle } from 'lqx-react';
import { asTimelessDate } from 'lqx-react/src/formatters';
import * as React from 'react';
import { Payment, Reconciliation } from 'src/app/pages/inmatch/api';
import { CustomerSupplier, RowH1, RowH2 } from '../../../../../../common/inmatch';

export const PaymentHeader = ({ payment, children, inline } : {
    payment : Payment,

    inline? : boolean
    children? : React.ReactNode
}) =>
    <PageHeaderTile
        toolbar={ children }
        noPaper={ inline }
        right={
            <>
                <ToleranceMeter payment={ payment } currency={ payment.currency } />
                <Space />
            </>
        }
        color={ colors[payment.color] }
        title={ inline ? <CustomerSupplier customer={ payment.customer } supplier={ payment.supplier } payorAgent={ payment.payorAgent }/> : null }
    >
        <Flex column>
            { inline ? null : <CustomerSupplier customer={ payment.customer } supplier={ payment.supplier } payorAgent={ payment.payorAgent } /> }
            <RowH1>{ asCurrency( payment.displayAmount, payment.currency ) }</RowH1>
            <Flex row wrap>
                <PageTileField label="Original Amount:">
                    { asCurrency( payment.amount, payment.currency ) }
                </PageTileField>
                
                <PageTileField label="Value Date:">
                    {asTimelessDate(payment.valueDate)}
                </PageTileField>
                
                <PageTileField label="Statement Date:">
                    {asTimelessDate(payment.statementDate)}
                </PageTileField>

                {/* <PageTileField label="Business Partner Code:">
                    {payment.conversation.customer.externalRelationshipId}
                </PageTileField> */}
                
                <PageTileField label="Creditor Bank Account:">
                    {payment.paymentDetail.creditorAccount}
                </PageTileField>
            </Flex>
            <AppLink href={ `/bank-transactions/details/${payment.id}` } returnUrl >
                    View More Details
            </AppLink>
        </Flex>        
    </PageHeaderTile>

const Space = div({
    minWidth: 54
})

export const InlinePaymentHeader = ({ payment, isValid, currency } : {
    payment : Payment | Reconciliation,
    isValid : () => boolean,
    currency : string,
}) =>
    <Flex column>
        <CustomerSupplier customer={ payment.customer } supplier={ payment.supplier }/>
        <Flex row>
            <Flex column grow>
                <RowH1 error={ !isValid() ? 1 : 0 }>{ asCurrency( payment.finalCashApplied, currency ) }</RowH1>
                <RowH2>Original Amount: { asCurrency( payment.cashReceived, currency ) }</RowH2>
                <RowH2>
                    Value Date: { asTimelessDate( payment.valueDate ) }
                </RowH2>
            </Flex>
            <Flex>
                <ToleranceMeter payment={ payment } currency={ currency } />
            </Flex>
        </Flex>
    </Flex>



export const ToleranceMeter = ({ payment, currency } : { payment: Payment | Reconciliation, currency: string }) => {
    const delta = payment.delta;
    const within = payment.isWithinTolerance(delta);

    return (
        <div> {
            within
                ?
                <ProgressCircle percentage={ 100 } label="within tolerance" color="green" footer={`Tolerance: ${asCurrency(payment.tolerance, currency)}`} />
                : ( // !delta ? null : // to ensure meter with NaN values is hidden
                    <ProgressCircle
                        percentage={ getPercentValue( -delta - payment.tolerance, -delta ) }
                        label="outside tollerance" color="yellow"
                        footer={`Tolerance: ${asCurrency(payment.tolerance, currency)}`}
                    >
                        <span> { asCurrency((-delta - payment.tolerance) || 0, currency) } </span>
                    </ProgressCircle>
                )
            }
        </div>
    );
}
